$(document).on("turbo:load", ()=>{
    let $public_access = $("main.public-access");
    if ($public_access.length){
       let $container = $("section.container").last();
        let $h2 = $container.find("h2");
        scrollToElement($h2);
    }


});







function scrollToElement(ele) {
    $(window).scrollTop(ele.offset().top-10).scrollLeft(ele.offset().left);
}